import { inject, injectable, injectFromBase } from 'inversify';
import { BaseEventListener } from '@kiplin/web-common/event';
import { MainLayoutDependencyTypes } from '@client/composition/main-layout/main-layout.dependency-types';
import type { MainLayoutNavigationRefreshService } from '@client/composition/main-layout/domain/service/main-layout-navigation-refresh.service';
import { ClientGamesRefreshRequestedEvent } from '@client/entity/client-game/domain/event/client-games-refresh-requested.event';
import type { ClientGamesRefreshCompletionDispatcherService } from '@client/entity/client-game/domain/service/client-games-refresh-completion-dispatcher.service';
import { ClientGameDependencyTypes } from '@client/entity/client-game/client-game.dependency-types';

@injectable()
@injectFromBase()
export class MainLayoutClientGamesRefreshRequestedListener extends BaseEventListener<ClientGamesRefreshRequestedEvent> {
  protected readonly eventClass = ClientGamesRefreshRequestedEvent;

  public constructor(
    @inject(MainLayoutDependencyTypes.MainLayoutNavigationRefreshService)
    private readonly mainLayoutNavigationRefreshService: MainLayoutNavigationRefreshService,
    @inject(ClientGameDependencyTypes.ClientGamesRefreshCompletionDispatcherService)
    private readonly completionDispatcher: ClientGamesRefreshCompletionDispatcherService,
  ) {
    super();
  }

  protected async handle(event: ClientGamesRefreshRequestedEvent): Promise<void> {
    try {
      await this.mainLayoutNavigationRefreshService.refresh();
      this.completionDispatcher.dispatchCompleted(event);
    } catch (error) {
      this.completionDispatcher.dispatchFailed(event, error);
    }
  }
}
